export const setUTCDateFormate = (
  date: Date | string = new Date(),
  preserveTime: boolean = false
) => {
  if (date instanceof Date) {
    const dateClone = new Date(date);

    if (!preserveTime) {
      dateClone.setUTCHours(0, 0, 0, 0);
    }

    return dateClone.toISOString();
  }
  return date;
};
